import {evolve} from 'ramda';
import {replace} from 'utils/objects';
import initState from './state';

export const parseUrlQuery = query => {
	const vals = evolve(
		{_page: Number, dismissPrompt: str => (str ? JSON.parse(str) : false)},
		query,
	);
	return {buildingsQuery: replace(vals, initState.buildingsQuery)};
};

export const formatUrlQuery = ({buildingsQuery}) => buildingsQuery;

export const formatBuildingsSearchInput = ({buildingsQuery}) => {
	return {
		city: buildingsQuery._city,
		street: buildingsQuery._street,
	};
};
